import React, {createContext, useContext, useState} from "react";

type NotificationType = "info" | "success" | "warning" | "error"

type NotificationData = {
    id?: number
    type: NotificationType
    title: string
    body: string
    duration?: number
}

type NotificationContext = {
    notifications: Array<NotificationData>
    notify: (type: NotificationType, title: string, body: string, duration?: number) => void
}

type Props = {
    children: React.ReactNode
}

const Context = createContext<NotificationContext>(null!)

/**
 * Context Provider
 */
export function NotificationProvider({children}: Props) {
    const [notifications, setNotifications] = useState<Array<NotificationData>>([]);

    function generateId(): number {
        return Date.now() + Math.round(Math.random() * 10000)
    }

    function notify(type: NotificationType, title: string, body: string, duration?: number): void {
        setNotifications([...notifications, {id: generateId(), type, title, body, duration}])
    }

    const contextValue = {notifications, notify}

    return <Context.Provider value={contextValue}>{children}</Context.Provider>
}

/**
 * Custom hook
 */
export function useNotifications(): NotificationContext {
    return useContext(Context)
}
